import { render, staticRenderFns } from "./BannersAds.vue?vue&type=template&id=57978488"
import script from "./BannersAds.vue?vue&type=script&lang=js"
export * from "./BannersAds.vue?vue&type=script&lang=js"
import style0 from "./BannersAds.vue?vue&type=style&index=0&id=57978488&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VCarousel,VCarouselItem})
